<template>
    <div class="row pb-5">
        <div class="col-12">
            <RankingRegentes :dataset="dataset" />
        </div>
    </div>
</template>

<script>
    import RankingRegentes from '../components/RankingRegentes.vue'

    export default {
        name:'graficosInvolucrados',
        props: {
            dataset: Array,
        },
        components: {      
            RankingRegentes
        },
    }
</script>